export default __webpack_public_path__ + "static/media/login-session.1bb24123.svg";